// tyhmrt-future-v1: #8246AF
// v2: #ea0437
// v3: #62A033
// v5: #8b4b07
// v5 :#FFDB00

export const lines = [
  //v1
  {
    name: '機場線延伸段',
    variant: 'tyhmrt-future-v1',
    info: '桃園捷運藍線北段，施工中，預計於2028年通車',
  },
  //v2
  {
    name: '捷運紅線',
    variant: 'tyhmrt-future-v2',
    info: '分段進行，整體進度在2024年2月底已達 1/3，預計在2030年完工',
  },
  //v3
  {
    name: '捷運綠線',
    variant: 'tyhmrt-future-v3',
    info: '預定2030年通車',
  },
  //v4
  {
    name: '捷運綠線延伸中壢',
    variant: 'tyhmrt-future-v3',
    info: '預定2031年通車',
  },
   //v5
  {
    name: '捷運棕線',
    variant: 'tyhmrt-future-v5',
    info: '2024年3月通過可行性研究及綜合規劃報告，力拼在2025年全線動工、2032年全面通車)',
  },
  // v6
  {
    name: '捷運三鶯延伸八德',
    variant: 'tyhmrt-future-v6',
    info: '規劃中，綜合規劃報告書獲行政院核定後9年完工',
  }
]

export const stations = [
  [{ name: '中壢 A23', address: '', lat: 24.952792, lng: 121.226008 }],
  //v2 紅線
  [
    { name: '平鎮', address: '', lat: 24.943091, lng: 121.214873 },
    { name: '中壢/A23', address: '', lat: 24.952792, lng: 121.226008 },
    { name: '中原', address: '', lat: 24.962869, lng: 121.24039 },
    {
      name: '內壢',
      address: '桃園縣中壢市中和路139號',
      lat: 24.9534545,
      lng: 121.2257365,
    },
    { name: '桃園醫院車站/永豐', address: '', lat: 24.976807, lng: 121.27056 },
    { name: '中路', address: '', lat: 24.984171, lng: 121.28966 },
    {
      name: '桃園',
      address: '桃園縣桃園市中正路1號',
      lat: 24.989119,
      lng: 121.314476,
    },
    { name: '鳳鳴', address: '', lat: 24.972878, lng: 121.336648 },
  ],
  //v3 綠線
  [
    { name: '建德興豐站 G01', address: '', lat: 24.930501, lng: 121.280935 },
    { name: '建國 G02', address: '', lat: 24.937367, lng: 121.289514 },
    { name: '麻園 G03', address: '', lat: 24.943085, lng: 121.297217 },
    { name: '大湳 G04', address: '', lat: 24.956235, lng: 121.298953 },
    {
      name: '忠勇西街 G05',
      address: '',
      lat: 24.968916,
      lng: 121.30134,
    },
    {
      name: '陽明公園 G06',
      address: '',
      lat: 24.979999,
      lng: 121.306025,
    },
    {
      name: '永和市場 G08',
      address: '',
      lat: 24.996551,
      lng: 121.309952,
    },
    { name: '民光 G09', address: '', lat: 25.003856, lng: 121.305198 },
    {
      name: '大興西路 G10',
      address: '',
      lat: 25.012274,
      lng: 121.300262,
    },
    {
      name: '展演中心 G11',
      address: '',
      lat: 25.016721,
      lng: 121.298712,
    },
    {
      name: '南崁轉運站/蘆興埤站 G12',
      address: '',
      lat: 25.028604,
      lng: 121.293069,
    },
    { name: '南竹 G13', address: '', lat: 25.038936, lng: 121.282928 },
    {
      name: '蘆竹工業區 G13a',
      address: '',
      lat: 25.05213,
      lng: 121.275752,
    },
    { name: '長興 G14', address: '', lat: 25.062626, lng: 121.267237 },
    {
      name: '航空城1站 G15',
      address: '',
      lat: 25.067174,
      lng: 121.255932,
    },
    {
      name: '航空城2站 G16',
      address: '',
      lat: 25.059322,
      lng: 121.246748,
    },
    {
      name: '航空城3站 G17',
      address: '',
      lat: 25.048747,
      lng: 121.235418,
    },
    { name: '菓林 G31', address: '', lat: 25.079769, lng: 121.258764 },
    { name: '坑口 G32', address: '', lat: 25.086362, lng: 121.266392 },
  ],
  // v4 綠線延伸中壢
  [
    { name: '建德興豐站 G01', address: '', lat: 24.930501, lng: 121.280935 },
    { name: 'GE01', address: '', lat: 24.932803, lng: 121.267881 },
    { name: 'GE02', address: '', lat: 24.934784,  lng: 121.259140 },
    { name: 'GE03', address: '', lat: 24.940041,  lng: 121.252132 },
    { name: 'GE04', address: '', lat: 24.947640,  lng: 121.245081 },
    { name: 'GE05', address: '', lat: 24.948373,  lng: 121.235105 },
  ],
  // v5 棕線
  [
     { name: 'BRH02', address: '', lat:24.992165,  lng: 121.323352, },
      { name: 'BRH03', address: '', lat: 24.996016, lng: 121.339953 },
      { name: 'BRH04', address: '', lat: 25.001322,  lng: 121.353960 },
      { name: 'BRH05', address: '', lat: 25.000698,  lng: 121.365947, },
      { name: 'BRH06', address: '', lat:25.017469, lng:  121.402982},
  ],
  // v6 三鶯延伸八德
  [
    { name: 'LB12a', address: '', lat: 24.960379,  lng: 121.319971 },
    { name: 'LB13', address: '', lat: 24.957200,  lng: 121.311903 },
    { name: 'LB14', address: '', lat: 24.955694,  lng: 121.298756 },
  ],
]
